module.exports = __webpack_public_path__ + "static/wp-338337d170b049f883ad803e00a23b7b.png";